<template>
  <div class="contract">
    <mt-header title="拒签原因">
      <mt-button icon="back" slot="left" @click="goback">返回</mt-button>
    </mt-header>
    <div class="refcontain">
      <textarea class="reasontextarea" placeholder="请输入拒签原因" maxlength=200 @input="descInput()" v-model="desc"></textarea>
      <div class="totalstyle">{{totalcount}}/200</div>
    </div>
    <div class="refusebtn">
      <mt-button size="large" type="primary" @click="refuse()">提&nbsp;&nbsp;交</mt-button>
    </div>
  </div>
</template>

<script>
import cheader from '@/components/header';
export default {
  data () {
    return {
      totalcount:0,
      desc:'',
      cid:this.$route.query.cid
    }
  },
  mounted(){
    this.initRefuse();
  },
  methods: {
  	initRefuse: function(){
  	  var that = this;
  	  this.$http.post(
          domain("_isRefuseed"),
          {
            'contractId':this.cid
          }
      )
      .then(function(response){
          if(response.data.code == "997"){
              that.$router.push("/main");
          }
          },function(error){
            console.log(error);
      })
  	},
    refuse: function(){
      if(this.desc == null || this.desc == ""){
        this.$toast("请输入拒签原因");
        return;
      }
      var that = this;
      this.$http.post(
          domain("_refuse"),
          {
            'contractId':this.cid,
            'refusetext':this.desc
          }
      )
      .then(function(response){
          if(response.data.code == "0"){
              that.$toast("拒签成功");
              that.$router.push("/main");
          }else{
             that.$toast("拒签失败");
             return;
          }  
          that.dataList=response.data.data;
          },function(error){
            console.log(error);
      })
    },
    descInput(){
     var txtVal = this.desc.length;
     this.totalcount = txtVal;
    },
    goback: function () {
      history.go(-1); //后退1页
    }
  },
  components:{
     cheader
  }
}
</script>
<style>
.refcontain{
  padding: 30px 40px 20px 20px;
  position: relative;
}
textarea{
  resize: none;
  width:100%; 
  height:160px;
  border:1px solid #c1c1c1;
  -ms-border-radius: 4px;
  -moz-border-radius: 4px;
  -o-border-radius: 4px;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  padding: 10px 10px 0 10px;
}
.refusebtn{
  padding: 0 20px;
}
.totalstyle{
  position: relative;
  font-size: 1rem;
  color: #c1c1c1;
  float:right;
  margin-top:-35px;
}
.reasontextarea{
  font-size: 1rem;
}
.reasontextarea::-webkit-input-placeholder{
   font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/module/contract/Refuse.vue